import { create } from "zustand";

export const useBlogStore = create((set, get) => ({
  blogs: [],
  setBlogs: (blogs) => set({ blogs }),
  getBlogById: (id) => get().blogs.find((b) => b.id === id),
  reset: () => set({ blogs: [] }),
}));
